import { render, staticRenderFns } from "./ReportValuation.vue?vue&type=template&id=16973db0&"
import script from "./ReportValuation.vue?vue&type=script&lang=ts&"
export * from "./ReportValuation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16973db0')) {
      api.createRecord('16973db0', component.options)
    } else {
      api.reload('16973db0', component.options)
    }
    module.hot.accept("./ReportValuation.vue?vue&type=template&id=16973db0&", function () {
      api.rerender('16973db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/reports/ReportValuation.vue"
export default component.exports